// extracted by mini-css-extract-plugin
module.exports = {"toggle":"LocaleSelectTrigger_toggle__OtNFv","languageCode":"LocaleSelectTrigger_languageCode__BGQXb","flagIcon":"LocaleSelectTrigger_flagIcon__JJGZu"};